"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var yup = _interopRequireWildcard(require("yup"));

var _molecules = require("../../components/molecules");

var _hocs = require("../../hocs");

var _Form = require("../../components/organisms/Form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var selectProps = {
  name: 'select',
  id: 'select-id',
  value: '',
  placeholder: 'Select an option',
  options: [{
    value: 1,
    label: 'Select an option 1'
  }, {
    value: 2,
    label: 'Select an option 2'
  }]
};

function Form(_ref) {
  var form = _ref.form,
      hydrateValues = _ref.hydrateValues;
  var control = form.control;
  (0, _react.useEffect)(function () {
    hydrateValues({
      requester: 'Hola mundo'
    });
  }, [hydrateValues]);
  return /*#__PURE__*/_react.default.createElement(_molecules.SectionWrapper, {
    title: "Datos de traslados",
    className: "bg-white"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grid grid-cols-3 gap-x-8"
  }, /*#__PURE__*/_react.default.createElement(_Form.FormInput, {
    label: "SOLICITANTE *",
    placeholder: "SOLICITANTE *",
    control: control,
    name: "requester"
  }), /*#__PURE__*/_react.default.createElement(_Form.FormSelect, _extends({
    label: "Select *",
    placeholder: "Select *",
    control: control
  }, selectProps))));
}

Form.propTypes = {
  form: _propTypes.default.object,
  hydrateValues: _propTypes.default.func
};
var schema = yup.object().shape({
  requester: yup.string().required('Requerido'),
  select: yup.string()
});

var _default = (0, _hocs.withForm)({
  schema: schema,
  defaultValues: {
    requester: '',
    select: ''
  },
  isActionSubmit: false,
  submitForm: console.log,
  confirmation: {
    title: 'Completar formulario',
    message: 'Esto es un mensaje de prueba'
  }
})(Form);

exports.default = _default;